import React, { useState, useEffect } from "react";
import { Container, Row, Col, Button, Card, Modal } from "react-bootstrap";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap-icons/font/bootstrap-icons.css";

// img
import Neilisland from "../assets/img/Neil island.jpg";
import Havelock from "../assets/img/havelock-island-package.jpg";
import portblair from "../assets/img/port Blair.jpg";
import Bartang from "../assets/img/baratang.jpeg";

import AOS from "aos";
import "aos/dist/aos.css";

import video from "../assets/img/homepage/video.jpeg";
import videoplay from "../assets/video/vid2.mp4";

const destinations = [
  {
    id: 1,
    name: "Havelock",
    img: Havelock,
    tours: "01 Tours",
  },
  {
    id: 2,
    name: "Neil Island",
    img: Neilisland,
    tours: "02 Tours",
  },
  {
    id: 3,
    name: "Port Blair",
    img: portblair,
    tours: "03 Tours",
  },
  {
    id: 4,
    name: "Bartang",
    img: Bartang,
    tours: "04 Tours",
  },
];

export default function Traveldestination() {
  const [showVideo, setShowVideo] = useState(false);

  useEffect(() => {
    AOS.init({ duration: 1100, once: true, easing: "ease-out-cubic" });
  }, []);

  return (
    <section className="home-dest-section py-10 container-fluid">
      <Container>
        {/* TOP BANNER */}
        <Row className="justify-content-center mb-5">
          <Col lg={12}>
            <div className="homedest-banner d-flex flex-column flex-lg-row overflow-hidden rounded-3">
              {/* Left banner (image + play) */}
              <div
                className="homedest-media position-relative"
                data-aos="fade-right"
              >
                <img
                  className="w-100 h-100 homedest-image"
                  src={video}
                  alt="beach"
                />

                <button
                  className="circle-play d-flex align-items-center justify-content-center"
                  onClick={() => setShowVideo(true)}
                  aria-label="Play video"
                  data-aos="zoom-in"
                  data-aos-delay="250"
                >
                  <i className="bi bi-play-fill" style={{ color: "black" }}></i>
                </button>
              </div>

              {/* Right CTA panel */}
              <div
                className="homedest-cta d-flex align-items-center justify-content-center"
                data-aos="fade-left"
              >
                <div className="cta-inner text-center text-lg-start p-4 p-lg-5">
                  <p className="cta-small mb-2">Enjoy Summer Deals</p>
                  <h3 className="cta-big mb-3">Up to 40% Discount!</h3>

                  <Button
                    className="take-tour-btn"
                    data-aos="fade-up"
                    data-aos-delay="200"
                  >
                    SEE DETAILS <i className="bi bi-arrow-right ms-2"></i>
                  </Button>
                  <div className="cta-illustration" aria-hidden />
                </div>
              </div>
            </div>
          </Col>
        </Row>

        {/* SECTION TITLE */}
        <Row className="text-center mb-4 py-6">
          <Col lg={8} className="mx-auto" data-aos="fade-up">
            <h2 className="mb-2 new-font">Next Adventure Destination</h2>

            <h2 className="section-title mb-3">
              Popular Travel Destinations <br /> Available Worldwide
            </h2>

            <p className="section-desc text-muted">
              Are you tired of the typical tourist destinations and looking to
              step out of your comfort zone? Travel with us to discover
              something new.
            </p>
          </Col>
        </Row>

        {/* DESTINATION CARDS */}
        <Row className="g-4 justify-content-center">
          {destinations.map((d, index) => (
            <Col
              key={d.id}
              xs={10}
              sm={5}
              md={3}
              lg={3}
              data-aos="zoom-in"
              data-aos-delay={index * 150}
            >
              <Card className="dest-card text-center shadow-sm">
                <div className="card-img-wrap position-relative">
                  <Card.Img variant="top" src={d.img} className="dest-img" />
                </div>
                <Card.Body className="pt-3">
                  <Card.Title className="fw-bold mb-1">{d.name}</Card.Title>
                </Card.Body>
              </Card>
            </Col>
          ))}
        </Row>
      </Container>

      {/* VIDEO MODAL */}
      <Modal
        show={showVideo}
        onHide={() => setShowVideo(false)}
        centered
        size="lg"
      >
        <Modal.Body className="p-0">
          <div className="ratio ratio-16x9">
            {/* Replace src with your own video */}
            <iframe
              src={videoplay}
              title="promo video"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowFullScreen
            />
          </div>
        </Modal.Body>

        <Modal.Footer>
          <Button variant="primary" onClick={() => setShowVideo(false)}>
            Close
          </Button>
        </Modal.Footer>
      </Modal>
    </section>
  );
}
